import { create } from 'zustand';
import { persist } from "zustand/middleware";

interface OffExchangeState {
  notAvailable: Array<string>;
  markUnavailable: (fips?: string, year?: number) => void;
}

function makeKey(fips: string, year: number) {
  return `${fips}-${year}`;
}

export const useOffExchangeStore = create<OffExchangeState>()(
  persist(
    (set) => ({
      notAvailable: [],

      markUnavailable: (fips, year) => {
        if (fips && year) {
          const key = makeKey(fips, year);
          set((state) => ({
            notAvailable: [...new Set([...state.notAvailable, key])],
          }));
        }
      },
    }),
    {
      name: "off-exchange-store", // key name in localStorage
      getStorage: () => localStorage, // optional, defaults to localStorage
    }
  )
);

export function useOffExchangeFilter({ fips, year }: { fips?: string, year?: number }) {
  const { notAvailable, markUnavailable } = useOffExchangeStore();

  const key = fips && year ? makeKey(fips, year) : undefined;
  const offExchangeDisabled = key && notAvailable.includes(key);

  return {
    offExchangeDisabled,
    markUnavailable,
  }
}